<script lang="ts">
    import { resolveCountdownStyling } from './_utils/resolveCountdownStyling';
    import CountdownView from './Countdown.View.svelte';

    import type { CountdownContent } from '$lib/types/Components/Countdown/CountdownContent';
    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let theme: Theme;
    export let content: CountdownContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let language: Language = 'en';

    $: styling = resolveCountdownStyling({ customColor: content.color, theme });
</script>

<CountdownView
    {id}
    box={content.box}
    color={styling.textColor}
    separatorColor={styling.separatorColor}
    gapClass={styling.gapClass}
    showSeconds={content.showSeconds}
    showLabels={content.showLabels}
    cycle={content.cycle}
    {language}
    datetime={content.datetime}
    {transitionDelay}
    {transitionEffect}
/>
